import * as constant from "./constants/Constant";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

let messaging;
if (!navigator?.userAgent?.match(/iPhone|iPad|iPod|Macintosh|FBAN|FBAV|Telegram|Instagram|MicroMessenger/i)) {
	// Your web app's Firebase configuration
	const firebaseConfig = {
		apiKey: constant.firebaseApiKey,
		authDomain: constant.firebaseAuthDomain,
		projectId: constant.firebaseProjectID,
		storageBucket: constant.firebaseStorageBucket,
		messagingSenderId: constant.firebaseMessagingSenderID,
		appId: constant.firebaseAppID,
		measurementId: constant.firebaseMeasurementID,
	};

	// Initialize Firebase
	const app = initializeApp(firebaseConfig);
	// const firebaseApp = initializeApp(firebaseConfig);
	messaging = getMessaging(app);
}

const GENERATED_MESSAGING_KEY = constant.firebaseGeneratedMessagingKey;

export const GetToken = () => {
	// Safety check: ensure Notification API exists and messaging is initialized
	if (typeof window.Notification === 'undefined' || !messaging) {
		console.log('GetToken: Notification API not supported or Firebase Messaging not initialized');
		return;
	}
	
	Notification.requestPermission().then((permission) => {
		console.log(permission);
		if (permission === "granted") {
			getToken(messaging, { vapidKey: GENERATED_MESSAGING_KEY })
				.then((currentToken) => {
					if (currentToken) {
						localStorage.setItem("firebaseToken", currentToken);
						// Track the token -> client mapping, by sending to backend server
						// show on the UI that permission is secured
					} else {
						console.log(
							"No registration token available. Request permission to generate one."
						);
						// shows on the UI that permission is required
					}
				})
				.catch((err) => {
					console.log("An error occurred while retrieving token. ", err);
					// catch error while creating client token
				});
		}
	});
};

export const onMessageListener = () => {
	// Safety check: ensure messaging is initialized
	if (!messaging) {
		console.log('onMessageListener: Firebase Messaging not initialized');
		return new Promise(() => {
		}); // Return a never-resolving promise to avoid crashes
	}

	return new Promise((resolve) => {
		onMessage(messaging, (payload) => {
			// console.log(payload);
			resolve(payload);
		});
	});
};
